import gql from 'graphql-tag';

export const APPLICATION_INSTANCE_FRAGMENT = gql`
  fragment ApplicationInstanceFragment on ApplicationInstance {
    id
    clientId
    applicationId
  }
`;
